import { render, staticRenderFns } from "./FreelancerArchivedTab.htm?vue&type=template&id=118ebb3f&"
import script from "./FreelancerArchivedTab.ts?vue&type=script&lang=js&"
export * from "./FreelancerArchivedTab.ts?vue&type=script&lang=js&"
import style0 from "./FreelancerArchivedTab.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../MyVacanciesTab.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports